import Vue from 'vue'
import createError from '@/components/errorMessage'
export default function creatError(props){
    const vm =new Vue({
        // h =createElement创建虚拟dom
        render(h){
            return h(createError,{props})
        }
    }).$mount()
    document.body.appendChild(vm.$el);
    const com = vm.$children[0]//vue组件
    com.remove=function(){
        document.body.removeChild(vm.$el);//移除dom
        vm.$destroy();//销毁vue实力
    }
    console.log(com);
    return com
}


// WEBPACK FOOTER //
// ./src/unit/creatError.js